import { getRequest } from '../services/requestHandler';
import { CtLocation } from '../models';

//5537, 3 for testing
export const getCtLocations = async () => {
  const url = `rnd/GetCtLocations?activeOnly=true`;
  const response = await getRequest<CtLocation>('GetCtLocations', url);
  return response;
};
